import { configureTagging } from '@walmart/sophia-tagging'
import config from './config'

export const logEventToDataCollection = configureTagging(config)

export * from './constants'
